import { Component, OnInit, Inject } from '@angular/core';
 import { Contact } from 'src/app/entity/Contact';
import { Prospect } from 'src/app/entity/prospect';
import { ContactService } from 'src/app/service/contact.service';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-contacts-client-dialog',
  templateUrl: './contacts-client-dialog.component.html',
  styleUrls: ['./contacts-client-dialog.component.css']
})
export class ContactsClientDialogComponent implements OnInit {

  prospect: Prospect;
  dataSource = new MatTableDataSource();


  constructor(  @Inject(MAT_DIALOG_DATA) public data: any,private contactService:ContactService,
  private dialogRef: MatDialogRef<ContactsClientDialogComponent> ) {
    this.prospect = this.data ;
     
    this.findContacts();
   }

  ngOnInit() {
   
  }

 


 
 
  findContacts() {
    //console.log("this.prospect"+JSON.stringify(this.prospect));
    
    this.contactService.findContactsByProspect(this.prospect.prospectId).subscribe(data => {
      this.dataSource.data = data;
 
    })

  }
newContact( ){
  let contact =new Contact();
  contact.nom='new Delegate'
  this.dialogRef.close(new Contact())
}
cancel(){
  this.dialogRef.close( )
}
  select(contact: Contact) {
   
    this.dialogRef.close(contact)
 
  }
 
 
 

}
